
import {filter} from 'rxjs/operators';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { GridComponent, GridDataResult, SelectionEvent, RowArgs } from '@progress/kendo-angular-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

import { UserProfileService, CustomersService, UserModel, CustomerModel, initCustomerModel } from '../../../core';
import { UsersListComponent } from '../shared/users-list/users-list.component';
import { AddEditCustomerComponent } from './add-edit-customer/add-edit-customer.component';
import { CustomersStateService } from '../shared/customers-state.service';

@Component({
  selector: 'app-manage-customers',
  templateUrl: './manage-customers.component.html',
  styleUrls: ['./manage-customers.component.scss']
})

export class ManageCustomersComponent implements OnInit, OnDestroy {
  customerList: {CustomerID: number, Name: string, UserCount: number }[] = [];
  currentCustomerIndex = 0;
  currentCustomer:CustomerModel = initCustomerModel();

  gridView: GridDataResult;
  sort: SortDescriptor[] = [];

  enableBlockingScreen:boolean = false;
  anotherCustID:any[]=[];
  subscriptions:Subscription[]=[];

  constructor(
    private customers:CustomersService
    ,private customerStateService: CustomersStateService
    ,private router:Router
    ,private route: ActivatedRoute
  ) { }
  ngOnInit() {
    const s1 = this.customerStateService.updatedCustomer
        .subscribe(customer => this.customerUpdated(customer))

    this.customers.getCustomerListWithUserCounts()
      .subscribe(
        data => {
          this.customerList = data;
          this.setupSortedGridView();
          if(this.customerList.length>0){
            this.anotherCustID = [this.customerList[0].CustomerID];
          }
          this.switchToCustomer(this.currentCustomerIndex);
        }
        , (err)=>{this.customerStateService.setBusy(false);console.log(err);}

      );
  const s2 = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd))
    .subscribe(
      ((e:NavigationEnd) => {
        let current =  this.router.routerState.snapshot.url;
        let crrnt = this.route.snapshot.url;
        if(current.endsWith('user-list')) {
          this.switchToCustomer(this.currentCustomerIndex);
          this.enableBlockingScreen=false;
        }
      }),
      (err)=>{this.enableBlockingScreen=false;console.log(err);}
    );
  const s3 = this.customerStateService.refreshCustomer
    .subscribe(() => this.switchToCustomer(this.currentCustomerIndex));

    if(this.router.url.includes("/customer"))
      this.enableBlockingScreen=true;

    this.subscriptions.push(s1,s2,s3);
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

 private mySelectionKey(context: RowArgs): string {
        return context.dataItem.ProductName + " " + context.index;
    }

  customerUpdated(customer: CustomerModel){
    this.enableBlockingScreen = false;
    if(customer === null){
      var dd = 1;//this.switchToCustomer(this.currentCustomerIndex);
    }else{
      let foundIndx = -1;
      const found = this.customerList.find( (cust,i) => {foundIndx = i; return cust.CustomerID === customer.CustomerId;});
      if(found){
        found.Name = customer.Name;
      }
      else{
        this.customerList.push( {CustomerID:customer.CustomerId,Name:customer.Name,UserCount:1});
        this.setupSortedGridView();
      }
    }
  }

  sortChange(sort: SortDescriptor[]): void {
        this.sort = sort;
        this.setupSortedGridView();
    }
  setupSortedGridView(){
    this.gridView = {
      data: orderBy(this.customerList, this.sort),
      total: this.customerList.length
    }
  }
  customerSelection(event:SelectionEvent){
    if(event.selectedRows && event.selectedRows[0]){
      this.switchToCustomer(event.selectedRows[0].index);
    }
  }
  switchToCustomer(index:number)
  {
    let customerList:{CustomerID:number,Name:string,UserCount:number}[] = this.gridView.data;
    if (customerList.length>index) {
      const custItem = customerList[index];
      //this.anotherCustID = custItem.CustomerID;
      this.customerStateService.setBusy(true);
      this.customers
        .getUserListingByCustomer(custItem.CustomerID)
        .subscribe(cust =>
        {
          let x = { ...this.currentCustomer };  //clone
          //let x = initCustomerModel();

          x.Name = custItem.Name;
          x.UserList = cust;
          x.CustomerId = custItem.CustomerID;
          this.currentCustomer = x;
          this.customerStateService.customerSelected(this.currentCustomer)
        }
        ,(err)=>{this.customerStateService.setBusy(false);console.log(err);}
        ,()=>{this.customerStateService.setBusy(false);}
      );
      this.currentCustomerIndex = index;
    }else{
      let x = initCustomerModel();
      x.Name = '';
      x.UserList = [];
      this.currentCustomer = x;
    }

  }
  editCustomer(){
    this.enableBlockingScreen = true;
    //this.router.navigate(['customer', this.currentCustomer.customerId], {relativeTo: this.route});
    this.router.navigate(['customer', {id:this.currentCustomer.CustomerId}], {relativeTo: this.route});

  }
  addCustomer(){

    // this.userListStyle = this.hideStyle;
    // this.addEditCustomerStyle = this.showStyle;
    this.enableBlockingScreen = true;
    this.router.navigate(['customer'], {relativeTo: this.route});
}
  cancelCustomerEdit(){
    // this.userListStyle = this.showStyle;
    // this.addEditCustomerStyle = this.hideStyle;
    this.enableBlockingScreen = false;
  }
  onTrackHeight(){

  }
  trackHeight:any;

}

export enum displayType{
  userList,
  addEditCustomer,
  addEditUser
}
